/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, SearchLinkField, TextField, SearchResultFieldProps } from 'framework/ui/field';
import { useAssetUrl } from 'domain/finance/assets/shared/useAssetRouting';

type AssetLinkProps = SearchResultFieldProps & {
  nameSource: string;
  isClickable?: boolean;
};

const AssetLink = ({ source, nameSource, isClickable, ...props }: AssetLinkProps) => {
  const { getValue } = useFieldHelper({ source });
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { getSingleEntityUrl } = useAssetUrl();
  const id = getValue();
  const name = getName();

  return isClickable ? (
    <SearchLinkField value={name || id} isInternal url={getSingleEntityUrl(id)} {...props} />
  ) : (
    <TextField source={source} value={name || id} />
  );
};

export default AssetLink;
